/**
 * loadScript
 */
export const loadScript = (filename: string, target: HTMLElement) => {
    const asset = document.createElement('script');
    asset.src = filename;
    const oldAsset = target.querySelector(`script[src="${filename}"]`);

    if (oldAsset) {
        target.removeChild(oldAsset);
    }

    target.appendChild(asset);
};

/**
 * loadStyleSheet
 */
export const loadStyleSheet = (filename: string, target: HTMLElement) => {
    const asset = document.createElement('link');
    asset.href = filename;
    asset.rel = 'stylesheet';

    target.appendChild(asset);
};
